import React from 'react';
import { Link } from "react-router-dom";
import '../styles/ContactSection.css';

const ContactSection = () => {
  return (
    <section className="contact">
      <div className="contact-container">
        <h2 className="contact-title">Kontakt</h2>

        <div className="contact-columns">
          <div className="contact-column">
            <h3>Softwareentwicklung & Digitale Lösungen</h3>
            <p>Rebecca Stelter</p>
            <a href="mailto:info@skilt.app" className="contact-email">
              info@skilt.app
            </a>
          </div>

          <div className="contact-divider"></div>

          <div className="contact-column">
            <h3>Technische Beratung & Gutachten</h3>
            <p>Florian Broschart</p>
            <a href="mailto:info@skilt.app" className="contact-email">
              info@skilt.app
            </a>
          </div>
        </div>

        <div className="contact-legal">
          <Link to="/impressum">Impressum</Link>
          <span> | </span>
          <Link to="/datenschutz">Datenschutz</Link>
          <span> | </span>
          <Link to="/agb">AGB</Link>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;